import type { SystemParameterKey } from '@library/enums'
import {
  fileInformationSchema,
  systemParameterSchema,
  type FileInformation,
  type SystemParameter
} from '@library/models'
import {
  errorMessageListSchema,
  type ErrorMessageList
} from '@library/models/error-message-list'
import {
  systemVersionSchema,
  type SystemVersion
} from '@library/models/system-version'
import type ApiFactory from '@library/services/api-factory'
import { apiValidator } from '@library/services/decorators'
import type { ApiResponse } from '@library/services/types/api-response'

export default class BfUnAuthApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 取得檔案資訊
   * 前台 - https://hackmd.io/_vZDOXESQtuA67PNoD723A
   * 後台 - https://hackmd.io/e2xsaWk-SFCk1YOC6cuzyA
   */
  @apiValidator(fileInformationSchema.array().nullable())
  getFileInformation(
    fileId: string[]
  ): Promise<ApiResponse<FileInformation[] | null>> {
    return this.api.post(
      'Common/GetFileInformation',
      { fileId },
      { headers: { ignoreRtnCodeError: ['3'] } }
    )
  }

  /**
   * API 取得系統參數
   * 前台 - https://hackmd.io/xPhmeGc6SGO2uXqm1cI3rA
   * 後台 - https://hackmd.io/BIvCBdt-SwePsckcEWqhtQ
   */
  @apiValidator(systemParameterSchema.array())
  getSysParameter(
    type: string[]
  ): Promise<ApiResponse<SystemParameter<SystemParameterKey>[]>> {
    return this.api.post('Common/GetSysParameter', { type })
  }

  /**
   * API 取得後端回傳代碼訊息
   * 前台 - https://hackmd.io/KZHR0G9gS867IOH1gUQSJA
   * 後台 - https://hackmd.io/t1waXRoGQb-ZwA9wnnPeSA
   */
  @apiValidator(errorMessageListSchema.array())
  getErrorMessageList(): Promise<ApiResponse<ErrorMessageList[]>> {
    return this.api.get('Common/GetReturnCodeMessage')
  }

  /**
   * API 取得系統版本資訊
   * 前台 - https://hackmd.io/b90p_LTxTlGIVVtEBC3RMg
   * 後台 - https://hackmd.io/XkLoHCiPSgSTqhlUa5icrw
   */
  @apiValidator(systemVersionSchema)
  getSysVersion(): Promise<ApiResponse<SystemVersion>> {
    return this.api.get('Common/GetSysVersion')
  }
}
